angular.module('offers')
    .factory('OfferStatus', function ($resource) {
        return $resource('/crm/api/offer-status');
    })
    .component('offerStatusLabel', {
        bindings: {
            status: '<'
        },
        template: `
            <span ng-if="$ctrl.status != null" class="label label-default offer-status-label-{{$ctrl.status}}">{{ 'offer.status.'.concat($ctrl.status) | translate }}</span>
        `
    })
